import React from "react";
import { Collapse } from "antd";
const { Panel } = Collapse;

const Faqsec1 = () => {
	const faqContent = [
		{
			question: "Do you offer support and what does Priority Support mean?",
			answer:
				"Yes, all our paid plans include support for questions related to your account, billing, or anything product associated. You can see here our support policy.For the plans that include Priority Support, the Happiness Engineers will handle the tickets with higher priority so you get a reply faster. Check how fast we answer to the support inquiries.",
		},
		{
			question:
				"For how many sites can I use the products?",
			answer:
				"",
		},
		{
			question: "Still, have a question?",
			answer:
				"",
		},
		{
			question: "Still, have a question?",
			answer:
				"",
		},
		{
			question: "Still, have a question?",
			answer:
				"",
		},
	];
	return (
		<>
			<section className='sec faq_pg_sec1'>
				<div className='container'>
					<div className='inner_wrap'>
						{/* <h2>Frequently Asked Questions?</h2> */}
						<div className='acc_wrap'>
							<Collapse accordion>
								{faqContent.map((val, index) => {
									return (
										<Panel
											header={val.question}
											key={index}>
											<p>{val.answer}</p>
										</Panel>
									);
								})}
							</Collapse>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Faqsec1;
